import { colors } from 'ui/theme/colors';
import { getColor } from 'ui/icons/utils';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const TriggerWorkflow24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M3 7C3 5.89543 3.89543 5 5 5H19C20.1046 5 21 5.89543 21 7V9C21 10.1046 20.1046 11 19 11H5C3.89543 11 3 10.1046 3 9V7Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M3 18C3 16.8954 3.89543 16 5 16H9C10.1046 16 11 16.8954 11 18V20C11 21.1046 10.1046 22 9 22H5C3.89543 22 3 21.1046 3 20V18Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M13 18C13 16.8954 13.8954 16 15 16H19C20.1046 16 21 16.8954 21 18V20C21 21.1046 20.1046 22 19 22H15C13.8954 22 13 21.1046 13 20V18Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 2V6H11V2H13ZM8 13V17H6V13H8ZM18 13V17H16V13H18Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
